// Tłumaczenia (vue-i18n) dla całej aplikacji: `$t` w szablonach, `useI18n()` w skryptach.
// Język ustawia useLanguage (na starcie ostatnio użyty na tym urządzeniu); <html lang> idzie za nim.
import { i18n } from '@/i18n/index.js'
import { language } from '@/composables/useLanguage.js'

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(i18n)
    useHead({ htmlAttrs: { lang: language } })
})
